// Form state types for alert rule management

// Form data interface
export interface AlertRuleFormData {
    id: string;
    hostid: number | string;
    datasourceid: number | string;
    name: string;
    entitytype: string;
    metrictype: string;
    intervalminutes: number;
    threshold: number;
    units: string;
    decreasing: string;
    disabled: boolean;
    statistic: string;
    aggregation: string;
}

// Form validation state
export interface AlertRuleFormValidation {
    name: {
        isValid: boolean;
        isUsed: boolean;
        className: string;
    };
    threshold: {
        isValid: boolean;
        className: string;
        message?: string;
    };
    statistic: {
        isValid: boolean;
        hasError: boolean;
    };
    isFormValid: boolean;
}

// Form UI state
export interface AlertRuleFormUIState {
    isMissing: boolean;
    isError: boolean;
    disabled: boolean;
    loading: boolean;
}

// Form dependencies data
export interface AlertRuleFormDependencies {
    // Can add dependencies like available metrics, hosts, instances etc.
}

// Complete form state
export interface AlertRuleFormState {
    formData: AlertRuleFormData;
    validation: AlertRuleFormValidation;
    uiState: AlertRuleFormUIState;
    dependencies: AlertRuleFormDependencies;
}

// Default values
export const createDefaultFormData = (): AlertRuleFormData => ({
    id: '',
    hostid: 0,
    datasourceid: 0,
    name: '',
    entitytype: 'host',
    metrictype: 'statistic',
    intervalminutes: 1,
    threshold: NaN,
    units: '',
    decreasing: 'false',
    disabled: false,
    statistic: 'cpuutilisation',
    aggregation: 'avg'
});

export const createDefaultValidation = (): AlertRuleFormValidation => ({
    name: {
        isValid: true,
        isUsed: false,
        className: ''
    },
    threshold: {
        isValid: true,
        className: '',
        message: undefined
    },
    statistic: {
        isValid: true,
        hasError: false
    },
    isFormValid: true
});

export const createDefaultUIState = (disabled: boolean = false): AlertRuleFormUIState => ({
    isMissing: false,
    isError: false,
    disabled,
    loading: false
});

export const createDefaultDependencies = (): AlertRuleFormDependencies => ({
    // Empty for now
});

